import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import DataTable, { TableColumn } from 'react-data-table-component';
import { PolicyBenefitLimit } from '@models/PolicyBenefitLimit';
import { formatCurrency } from '@utils/currency';
import { policyBenefitLimitsWithAccumulatedPaidAmountsFetch } from './action';
import { selectHealthClaim } from './selector';

const customStyles = {
  headCells: {
    style: {
      fontWeight: 'bold',
    },
  },
};

export const AccumulatedClaimsTabContent = ({ insurancePolicyUserId }: { insurancePolicyUserId: number }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { policyBenefitLimitsWithAccumulatedPaidAmounts } = useSelector(selectHealthClaim);

  useEffect(() => {
    const payload = { id: insurancePolicyUserId };
    dispatch(policyBenefitLimitsWithAccumulatedPaidAmountsFetch(payload));
  }, [insurancePolicyUserId]);

  const policyBenefitLimitsColumns: TableColumn<PolicyBenefitLimit>[] = [
    {
      name: t('common:benefit'),
      selector: (row) => row.benefit,
      wrap: true,
    },
    {
      name: t('common:subBenefit'),
      selector: (row) => row.subBenefit,
      wrap: true,
    },
    {
      name: t('common:limitAmount'),
      cell: (row) => formatCurrency(row.limitAmount),
    },
    {
      name: t('common:description'),
      selector: (row) => row.description,
      wrap: true,
    },
    {
      name: t('common:accumulatedPaidAmount'),
      selector: (row) => formatCurrency(row.accumulatedPaidAmount),
      wrap: true,
    },
  ];

  return (
    <DataTable
      columns={policyBenefitLimitsColumns}
      data={policyBenefitLimitsWithAccumulatedPaidAmounts ?? []}
      customStyles={customStyles}
      fixedHeader
    />
  );
};
